import { fetchForm, setFormSubmitButtonEnabled, apiPost } from "./api";
import { Analytics } from "./analytics";

function handleLoginRedirect(form, defaultPath) {
    const redirect = getRedirect(form, defaultPath);
    redirectToPath(redirect);
}

function getRedirect(form, defaultPath)
{
    const params = new URLSearchParams(window.location.search.substring(1));
    let redirect = defaultPath;

    if (params.has('returnTo')) {
        const returnTo = params.get('returnTo');
        if (returnTo && returnTo[0] === '/') {
            redirect = returnTo;
        }
    } else if (form.getAttribute('data-return')) {
        const retVal = form.getAttribute('data-return');
        redirect = retVal;
    }

    return redirect;
}

function redirectToPath(redirect)
{
    if (redirect === 'reload') {
        window.location.reload();
    } else if (redirect) {
        window.location.href = redirect;
    }
}

function showUpdateAccountModal(redirect) {
    const updateAccountModal = document.getElementById('update-account-modal');
    if (updateAccountModal) {
        updateAccountModal.classList.add('!translate-y-0')
        updateAccountModal.classList.add('!opacity-100');
        updateAccountModal.parentElement.classList.remove('hidden');
        updateAccountModal.setAttribute('data-redirect', redirect);

        updateAccountModal.querySelectorAll('button[data-update-account][name="accept"]').forEach((button) => {
            button.removeEventListener('click');
            button.addEventListener('click', acceptUpdateAccount);
        });

        updateAccountModal.querySelectorAll('button[data-update-account][name="close"]').forEach((button) => {
            button.removeEventListener('click');
            button.addEventListener('click', closeUpdateAccountModal);
        });
    }
}

function acceptUpdateAccount() {
    const updateAccountModal = document.getElementById('update-account-modal');
    if (updateAccountModal) {
        const redirect = updateAccountModal.getAttribute('data-redirect');
        window.location.href = '/account/update?returnTo=' + redirect;
    }
}

function closeUpdateAccountModal() {
    const updateAccountModal = document.getElementById('update-account-modal');
    if (updateAccountModal) {
        updateAccountModal.classList.remove('!translate-y-0')
        updateAccountModal.classList.remove('!opacity-100');
        updateAccountModal.parentElement.classList.add('hidden');

        const redirect = updateAccountModal.getAttribute('data-redirect');
        redirectToPath(redirect);
    }
}

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#().,^\-_])[A-Za-z\d@$!%*?&#().,^\-_]{8,}$/

// Must match RecaptchaHelper::ACTION_CREATE_ACCOUNT - the server rejects a token minted
// for a different action.
const RECAPTCHA_ACTION_CREATE_ACCOUNT = 'create_account';
const RECAPTCHA_TIMEOUT_MS = 5000;

/**
 * Resolves to a token, or to an empty string when reCAPTCHA is unavailable. Never rejects -
 * the server decides whether an empty token is acceptable, so that stays in one place.
 */
function getRecaptchaToken(action) {
    if (!window.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
        return Promise.resolve('');
    }

    return new Promise((resolve) => {
        // If ready() never fires the form would sit with its submit button disabled, so cap
        // the wait and let the submission proceed to a clear server-side error.
        const timeout = setTimeout(() => resolve(''), RECAPTCHA_TIMEOUT_MS);

        const finish = (token) => {
            clearTimeout(timeout);
            resolve(token || '');
        };

        try {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(window.recaptchaSiteKey, { action: action })
                    .then(finish)
                    .catch(() => finish(''));
            });
        } catch (err) {
            finish('');
        }
    });
}

$(document).ready(function () {
    const createAccountForm = document.querySelector('form[data-ticketing][name="create-account-form"]');
    const updateAccountForm = document.querySelector('form[data-ticketing][name="update-account-form"]');
    const loginForm = document.querySelector('form[data-ticketing][name="login-form"]');
    const passwordResetForm = document.querySelector('form[data-ticketing][name="password-reset-form"]');
    const passwordUpdateForm = document.querySelector('form[data-ticketing][name="password-update-form"]');

    // Attach ajax handler for Create Account form
    if (createAccountForm) {
        createAccountForm.addEventListener('submit', (event) => {
            const acceptTcPpCS = createAccountForm.querySelector('input[name="acceptTcPpCS"]');
            event.preventDefault();

            if (!acceptTcPpCS?.checked) {
                return;
            }

            const tokenField = createAccountForm.querySelector('input[name="recaptchaToken"]');

            // Disabled up front so the token fetch cannot be double-submitted.
            setFormSubmitButtonEnabled(createAccountForm, false);

            // Minted at submit time, not page load - v3 tokens expire after two minutes.
            getRecaptchaToken(RECAPTCHA_ACTION_CREATE_ACCOUNT).then((token) => {
                if (tokenField) {
                    tokenField.value = token;
                }

                return fetchForm(event.target);
            }).then((resp) => {
                Analytics.userSignUp();
                handleLoginRedirect(event.target,'/');
            }).catch((err) => {
                setFormSubmitButtonEnabled(createAccountForm, true);
            });
        });
    }

    // Update account form
    if (updateAccountForm) {
        const emailInput = updateAccountForm.querySelector('input[name="email"]');
        const confirmEmailInput = updateAccountForm.querySelector('input[name="confirmEmail"]');
        const passwordInput = updateAccountForm.querySelector('input[name="password"]');
        const confirmPasswordInput = updateAccountForm.querySelector('input[name="confirmPassword"]');

        updateAccountForm.addEventListener('submit', (event) => {
            event.preventDefault();

            fetchForm(event.target).then((resp) => {
                handleLoginRedirect(event.target, '/account');
            }).catch((err) => {
                setFormSubmitButtonEnabled(updateAccountForm, true);
            });
        });

        emailInput.addEventListener('change', (event) => {
            const originalEmail = emailInput.getAttribute('data-original');

            if (originalEmail !== emailInput.value) {
                confirmEmailInput.parentElement.classList.remove('hidden');
                confirmEmailInput.disabled = false;
            } else {
                confirmEmailInput.parentElement.classList.add('hidden');
                confirmEmailInput.disabled = true;
            }
        });

        passwordInput.addEventListener('change', (event) => {
            if (passwordInput.value.length) {
                confirmPasswordInput.parentElement.classList.remove('hidden');
                confirmPasswordInput.disabled = false;
            } else {
                confirmPasswordInput.parentElement.classList.add('hidden');
                confirmPasswordInput.disabled = true;
            }
        });
    }

    // Login form
    if (loginForm) {
        loginForm.addEventListener('submit', (event) => {
            event.preventDefault();

            fetchForm(event.target).then((resp) => {
                if (window.localStorage) {
                    window.localStorage.removeItem('password-reset-redirect');
                }

                Analytics.userLogin();
                if (resp['update-account-needed']) {
                    showUpdateAccountModal(getRedirect(event.target, '/account'));
                } else {
                    handleLoginRedirect(event.target, '/account');
                }
            }).catch((err) => {
                setFormSubmitButtonEnabled(loginForm, true);
            });
        });
    }

    // Logout buttons
    document.querySelectorAll('[name="logoutButton"],[data-logout]').forEach((logoutButton) => {
        logoutButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            apiPost('logout').finally(() => {
                window.location.href = '/';
            })
        });
    });

    // Password Reset form
    if (passwordResetForm) {
        passwordResetForm.addEventListener('submit', (event) => {
            event.preventDefault();
            fetchForm(event.target).then((resp) => {
                const messageEle = document.getElementById('password-reset-message');
                messageEle.classList.remove('hidden');
                passwordResetForm.classList.add('hidden');

                if (window.localStorage) {
                    window.localStorage.removeItem('password-reset-redirect');

                    const params = new URLSearchParams(window.location.search.substring(1));
                    if (params.has('returnAfter')) {
                        const returnTo = params.get('returnAfter');
                        if (returnTo && returnTo[0] === '/') {
                            window.localStorage.setItem('password-reset-redirect',returnTo);
                        }
                    }
                }
            }).catch((err) => {
                setFormSubmitButtonEnabled(passwordResetForm, true);
            });
        });
    }

    if (passwordUpdateForm) {
        passwordUpdateForm.addEventListener('submit', (event) => {
            event.preventDefault();
            fetchForm(event.target).then((resp) => {
                const messageEle = document.getElementById('password-reset-success');

                const returnTo = window.localStorage ? window.localStorage.getItem('password-reset-redirect') : null;
                if (returnTo && returnTo[0] === '/') {
                    const loginAnchor = messageEle.querySelector('a');
                    loginAnchor.href += `?returnTo=${encodeURIComponent(returnTo)}`;
                }

                messageEle.classList.remove('hidden');
                passwordUpdateForm.classList.add('hidden');
            }).catch((err) => {
                setFormSubmitButtonEnabled(passwordUpdateForm, true);
            });
        });
    }

    document.querySelectorAll('input[name="confirmPassword"]').forEach((confirmPasswordInput) => {
        const form = confirmPasswordInput.closest('form');
        const passwordInput = form.querySelector('input[name="password"]');

        const showPasswordError = (input, show, msg) => {
            const errorMsg = form.querySelector(`*[name="${input.name}"]~div.form-error`);

            if (show) {
                errorMsg.innerText = msg;
            } else {
                errorMsg.innerText = '';
            }
        };

        const showPasswordValidImage = (input, show) => {
            const successImg = form.querySelector(`*[name="${input.name}"]~div.password-icon`);

            if (show) {
                successImg.classList.remove('hidden');
            } else {
                successImg.classList.add('hidden');
            }
        };

        const changeFunc = (e) => {
            let hasError = false;

            for (let pwInput of [passwordInput,confirmPasswordInput]) {
                showPasswordError(pwInput, false);
                showPasswordValidImage(pwInput,false);

                if (!pwInput.value) {
                    showPasswordError(pwInput, false);

                    hasError = true;
                }
                else {
                    const pwValid = PASSWORD_REGEX.test(pwInput.value);

                    if (!pwValid) {
                        showPasswordError(pwInput, true, 'Password does not meet our complexity requirements');

                        hasError = true;
                    } else {
                        if (pwInput === passwordInput) {
                            showPasswordValidImage(passwordInput,true);
                        }
                    }
                }
            }

            if (passwordInput.value && confirmPasswordInput.value) {
                const pwMatches = passwordInput.value === confirmPasswordInput.value;

                if (!pwMatches) {
                    showPasswordError(confirmPasswordInput, true, 'Password and Confirm Password fields must match');

                    hasError = true;
                }

                if (!hasError) {
                    showPasswordValidImage(passwordInput,true);
                    showPasswordValidImage(confirmPasswordInput,true);
                }
            }
        };

        passwordInput.addEventListener('change', changeFunc);
        confirmPasswordInput.addEventListener('change', changeFunc);
    });

    // only allow numeric characters inside phone inputs
    // difference to type=number is that this is still treated as text and retains leading zeros
    document.querySelectorAll('input[name="phone"]').forEach((input) => {
        input.addEventListener('input', (e) => {
            e.target.value = e.target.value.replace(/[^0-9]/g,'');
        });
    });
});